let activeCurrency = 'TRY';

export function setActiveCurrency(currency) {
  const raw = String(currency || '').toUpperCase();
  activeCurrency = raw === 'EUR' || raw === 'USD' ? raw : 'TRY';
  return activeCurrency;
}

export function getActiveCurrency() {
  return activeCurrency;
}

export function currencyCode(currency) {
  const code = String(currency || activeCurrency).toUpperCase();
  if (code === 'EUR') return 'EUR';
  if (code === 'USD') return 'USD';
  return 'TL';
}

export function formatMoney(amount, currency) {
  const value = Number(amount || 0);
  const formatted = Number.isInteger(value) ? String(value) : value.toFixed(2);
  return `${formatted}\u00a0${currencyCode(currency)}`;
}

export function formatUsd(amount) {
  const value = Number(amount || 0);
  if (!Number.isFinite(value)) return '$0.00';
  return `$${value.toFixed(2)}`;
}

export function formatTryTr(amount) {
  const value = Number(amount || 0);
  if (!Number.isFinite(value)) return '0,00 TL';
  const fixed = value.toFixed(2);
  const [intPart, dec] = fixed.split('.');
  const withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withDots},${dec} TL`;
}

export function usdToTryAmount(amountUsd, usdtTry) {
  const usd = Number(amountUsd);
  const rate = Number(usdtTry);
  if (!Number.isFinite(usd) || !Number.isFinite(rate) || rate <= 0) return null;
  return Math.round(usd * rate * 100) / 100;
}

export function formatUsdWithTry(amountUsd, usdtTry) {
  const usd = Number(amountUsd);
  const tryAmount = usdToTryAmount(usd, usdtTry);
  if (!Number.isFinite(usd)) return formatMoney(0);
  if (tryAmount == null) return formatUsd(usd);
  return `${formatUsd(usd)} (${formatTryTr(tryAmount)})`;
}
